import { useState } from 'react';
import { supabase } from './supabase';

export default function Login({ onLogin }) {
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      onLogin();
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#F4F6F8',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Inter', sans-serif"
    }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800&family=Inter:wght@400;500;600&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .login-input {
          width: 100%; padding: 12px 14px; border: 1.5px solid #e2e8f0;
          border-radius: 8px; font-size: 14px; font-family: 'Inter', sans-serif;
          background: #fff; color: #0A2540; outline: none;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .login-input:focus { border-color: #0A2540; box-shadow: 0 0 0 3px rgba(10,37,64,0.08); }
        .login-btn {
          width: 100%; padding: 13px; background: #D92D20; border: none;
          border-radius: 8px; color: white; font-size: 14px; font-weight: 700;
          font-family: 'Inter', sans-serif; cursor: pointer; letter-spacing: 0.02em;
          transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
        }
        .login-btn:hover { background: #b82419; transform: translateY(-1px); box-shadow: 0 4px 14px rgba(217,45,32,0.3); }
        .login-btn:active { transform: translateY(0); }
        .login-btn:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
        @keyframes fadeUp { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
        .login-card { animation: fadeUp 0.4s cubic-bezier(0.4,0,0.2,1) both; }
      `}</style>

      <div className="login-card" style={{
        background: 'white', borderRadius: 16, padding: '48px 44px',
        width: '100%', maxWidth: 420,
        boxShadow: '0 8px 40px rgba(10,37,64,0.12), 0 1px 4px rgba(10,37,64,0.06)'
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div style={{
            width: 56, height: 56, background: '#0A2540', borderRadius: 14,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px', boxShadow: '0 4px 14px rgba(10,37,64,0.2)'
          }}>
            <span style={{ fontFamily: "'Montserrat',sans-serif", fontWeight: 800, fontSize: 22, color: 'white' }}>P</span>
          </div>
          <div style={{ fontFamily: "'Montserrat',sans-serif", fontWeight: 800, fontSize: 22, color: '#0A2540', letterSpacing: '0.01em' }}>
            PACT<span style={{ color: '#D92D20' }}>.</span>HEALTH
          </div>
          <div style={{ fontSize: 12, color: '#7a8a9a', marginTop: 4, letterSpacing: '0.08em', textTransform: 'uppercase', fontWeight: 600 }}>
            PT Intelligence
          </div>
        </div>

        <div style={{ marginBottom: 28 }}>
          <div style={{ fontSize: 20, fontFamily: "'Montserrat',sans-serif", fontWeight: 700, color: '#0A2540', marginBottom: 6 }}>
            Welcome back
          </div>
          <div style={{ fontSize: 13, color: '#7a8a9a' }}>
            Sign in to your coaching dashboard
          </div>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#0A2540', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              Email
            </label>
            <input
              className="login-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="coach@example.com"
              required
            />
          </div>

          <div style={{ marginBottom: 24 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
              <label style={{ fontSize: 12, fontWeight: 600, color: '#0A2540', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                Password
              </label>
              <span style={{ fontSize: 12, color: '#D92D20', cursor: 'pointer', fontWeight: 500 }}>
                Forgot password?
              </span>
            </div>
            <input
              className="login-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              required
            />
          </div>

          {error && (
            <div style={{
              background: '#fef2f1', border: '1px solid rgba(217,45,32,0.2)',
              borderLeft: '3px solid #D92D20', borderRadius: 8,
              padding: '10px 14px', marginBottom: 16,
              fontSize: 13, color: '#D92D20', fontWeight: 500
            }}>
              {error}
            </div>
          )}

          <button className="login-btn" type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign in'}
          </button>
        </form>

        <div style={{ marginTop: 24, textAlign: 'center', fontSize: 12, color: '#7a8a9a' }}>
          Need access?{' '}
          <span style={{ color: '#0A2540', fontWeight: 600, cursor: 'pointer' }}>
            Contact your administrator
          </span>
        </div>

        <div style={{ marginTop: 32, paddingTop: 20, borderTop: '1px solid #e2e8f0', textAlign: 'center' }}>
          <div style={{ fontSize: 11, color: '#7a8a9a' }}>
            Powered by <span style={{ fontWeight: 700, color: '#0A2540' }}>PACT.HEALTH</span> · PT Intelligence Platform
          </div>
        </div>
      </div>
    </div>
  );
}
